import { notificationActionTypes } from './notification.types'

const INITIAL_STATE = {
  count: 0,
  messages: [],
  oldMessage: 0,
  rooms: [],
  // Nova estrutura de notificações
  notifications: [],
  unreadCount: 0
}

const notificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case notificationActionTypes.SET_NOTIFICATION_COUNT:
      return {
        ...state,
        count: action.payload,
        roomId: action.roomId,
        oldMessage: action.oldMessage
      }
    case notificationActionTypes.SET_MESSAGE:
      return {
        ...state,
        messages: action.payload,
      }
    case notificationActionTypes.SET_ROOMID:
      return {
        ...state,
        rooms: state.rooms.includes(action.payload) ? state.rooms : [...state.rooms, action.payload]
      }
    
    // Novas ações para notificações da API
    case notificationActionTypes.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      };
    
    case notificationActionTypes.SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload
      };
    
    case notificationActionTypes.ADD_NOTIFICATION:
      // Se a notificação já tem ID (vinda da API), usar ela diretamente
      if (action.payload.id) {
        return {
          ...state,
          notifications: [action.payload, ...state.notifications],
          unreadCount: action.payload.is_read ? state.unreadCount : state.unreadCount + 1
        };
      }
      
      // Se não tem ID, criar uma notificação local (fallback)
      const newNotification = {
        id: Date.now(),
        type: action.payload.type,
        title: action.payload.title,
        message: action.payload.message,
        room_id: action.payload.room_id,
        is_read: false,
        data: action.payload,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      return {
        ...state,
        notifications: [newNotification, ...state.notifications],
        unreadCount: state.unreadCount + 1
      };
    
    case notificationActionTypes.MARK_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          notification.id === action.payload ? { ...notification, is_read: true } : notification
        ),
        unreadCount: Math.max(0, state.unreadCount - 1)
      };
    
    case notificationActionTypes.CLEAR_NOTIFICATION:
      const notificationToRemove = state.notifications.find(n => n.id === action.payload);
      const wasUnread = notificationToRemove && !notificationToRemove.is_read;
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload),
        unreadCount: wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount
      };
    
    case notificationActionTypes.CLEAR_ALL:
      return {
        ...state,
        notifications: [],
        unreadCount: 0
      };
    
    case notificationActionTypes.MARK_ALL_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map(notification => ({ ...notification, is_read: true })),
        unreadCount: 0
      };

    default:
      return state
  }
}

export default notificationReducer;